<template>
  <card-container-layout>
    <div class="report__title-card-container">
      <div>
        <div class="report__title-card-icon-container">
          <title-card-icon></title-card-icon>
        </div>
      </div>
      <div class="report__title-card-title-container">
        <slot name="title-component"></slot>
      </div>
    </div>
  </card-container-layout>
</template>
<script>
import CardContainerLayout from '../Common/CardContainerLayout.vue';
import {REPORT_BORDER_RADIUS} from '../constants';
import TitleCardIcon from '../Icons/TitleCardIcon.vue';
export default {
  props: {
    contentAlignment: String,
  },
  components: {
    TitleCardIcon,
    CardContainerLayout,
  },
  computed: {
    styles() {
      return {
        borderRadius: REPORT_BORDER_RADIUS,
      };
    },
  },
};
</script>

<style scoped>
.report__title-card-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.report__title-card-icon-container {
  background-color: #f9f9fb;
  padding: 20px;
}
.report__title-card-title-container {
  margin-left: 20px;
}
</style>
